module.exports = __webpack_public_path__ + "media/images/icn-cal-small-white-d38212c7c3d4dfa015242409131ea939.png";